export default "__VITE_ASSET__BhVKYZ32__"